import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/galerias',
		component: Base,
		children: [
			{
				path: '',
				name: 'GaleriasList',
				component: List,
				meta: {
					path: '/site/galerias',
					pai: 'Site',
					title: 'Admin - Galerias',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Galerias',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'GaleriasNovo',
				component: Form,
				meta: {
					path: '/site/galerias',
					pai: 'Site',
					title: 'Admin - Galerias - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Galerias',
						class: '',
						active: false,
						url: '/site/galerias'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'GaleriasEditar',
				component: Form,
				meta: {
					path: '/site/galerias',
					pai: 'Site',
					title: 'Admin - Galerias - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Galerias',
						class: '',
						active: false,
						url: '/site/galerias'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]